import './App.css';
import { Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import AboutUsPage from './pages/AboutUs';
import SustainabilityPage from './pages/Sustainability';
import NotFoundPage from './pages/NotFoundPage';
import Header from './Components/Header';
import Footer from './Components/Footer';
import ProductGrouseSatin from './pages/ProductGrouseSatin';
import ProductNFX from './pages/ProductNFX';
import ProductNFP from './pages/ProductNFP';
import ProductGrouseSatinMaxi from './pages/ProductGrouseSatinMaxi';
import ProductNFXMaxi from './pages/ProductNFXMaxi';
import ProductNFPMaxi from './pages/ProductNFPMaxi';
import ProductsPage from './pages/ProductsPage';
import ScrollToTop from './Components/ScrollToTop';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/sustainability" element={<SustainabilityPage />} />
          <Route path="/product-grouse-satin" element={<ProductGrouseSatin />} />
          <Route path="/product-nfx" element={<ProductNFX />} />
          <Route path="/product-nfp" element={<ProductNFP />} />
          <Route path="/product-grouse-satin-maxi" element={<ProductGrouseSatinMaxi />} />
          <Route path="/product-nfx-maxi" element={<ProductNFXMaxi />} />
          <Route path="/product-nfp-maxi" element={<ProductNFPMaxi />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;